import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import PrivateRoute from 'components/routing/PrivateRoute';
import PublicRoute from 'components/routing/PublicRoute';

import Login from 'pages/Login';
import Home from 'pages/Home';
import Accounts from 'pages/Accounts';
import UpdateAccount from 'pages/UpdateAccount';
import CustomerBin from 'pages/CustomerBin';
import CustomerInfo from 'pages/CustomerInfo';
import CustomerRegister from 'pages/CustomerRegister';
import { Regions, RegionInvoicing } from 'pages/Invoicing';
import AuditingList from 'pages/AuditingList';
import AuditingAppointment from 'pages/AuditingAppointment';
import Users from 'pages/Users';
import ManageUser from 'pages/ManageUser';
import AccountAccess from 'pages/ManageUser/AccountAccess';
import UserRegistration from 'pages/UserRegistration';
import PasswordReset from 'pages/PasswordReset';
import SubmitAppointment from 'pages/SubmitAppointment';
import ViewForms from 'pages/ViewForms';
import TwoStepVerification from 'pages/TwoStepVerification';

import WXWO from 'pages/FormAudit/Forms/WXWO';
import AIWO from 'pages/FormAudit/Forms/AIWO';
import DUCT from 'pages/FormAudit/Forms/DUCT';
import NGAT from 'pages/FormAudit/Forms/NGAT';
import NOC from 'pages/FormAudit/Forms/NOC';
import WASHER from 'pages/FormAudit/Forms/WASHER';
import SCE from 'pages/FormAudit/Forms/SCE';

import ThermCalculator from 'pages/ThermCalculator';
import PRThermCalculator from 'pages/PRThermCalculator';
import LeadFetcher from 'pages/LeadFetcher';
import ThermReport from 'pages/ThermReport/ThermReport';

// inspection pages
import InspectionPage1 from "pages/FormAudit/Forms/state-forms/inspection/page-1";
import InspectionPage2 from "pages/FormAudit/Forms/state-forms/inspection/page-2";
import InspectionPage3 from "pages/FormAudit/Forms/state-forms/inspection/page-3";
import InspectionPage4 from "pages/FormAudit/Forms/state-forms/inspection/page-4";
import InspectionPage5 from "pages/FormAudit/Forms/state-forms/inspection/page-5";
import InspectionPage6 from "pages/FormAudit/Forms/state-forms/inspection/page-6";
import InspectionPage7 from "pages/FormAudit/Forms/state-forms/inspection/page-7";
import InspectionPage8 from "pages/FormAudit/Forms/state-forms/inspection/page-8";
import InspectionPage9 from "pages/FormAudit/Forms/state-forms/inspection/page-9";
import InspectionPage10 from "pages/FormAudit/Forms/state-forms/inspection/page-10";
import InspectionPage11 from "pages/FormAudit/Forms/state-forms/inspection/page-11";

// repaired and replaced pages
import RepairedAndReplacedPage1 from "pages/FormAudit/Forms/state-forms/repair-and-replace/page-1";
import RepairedAndReplacedPage2 from "pages/FormAudit/Forms/state-forms/repair-and-replace/page-2";

// cas interm
import CASInterim from "pages/FormAudit/Forms/state-forms/interim";

// window and door
import WindowAndDoor from 'pages/FormAudit/Forms/state-forms/window-and-door';

// notice of survey
import NoticeOfSurvey from 'pages/FormAudit/Forms/state-forms/notice-of-survey';

// insulation certificate
import InsulationCertificate from 'pages/FormAudit/Forms/state-forms/insulation-certificate';

// compliance report pages
import ComplianceReportPage1 from "pages/FormAudit/Forms/state-forms/compliance-report/page-1";
import ComplianceReportPage2 from "pages/FormAudit/Forms/state-forms/compliance-report/page-2";
import ComplianceReportPage3 from "pages/FormAudit/Forms/state-forms/compliance-report/page-3";

// duct leakage pages
import DuctLeakagePage1 from "pages/FormAudit/Forms/state-forms/duct-leakage/page-1";
import DuctLeakagePage2 from "pages/FormAudit/Forms/state-forms/duct-leakage/page-2";
import DuctLeakagePage3 from "pages/FormAudit/Forms/state-forms/duct-leakage/page-3";

// shell leakage pages
import ShellLeakagePage1 from "pages/FormAudit/Forms/state-forms/shell-leakage/page-1";
import ShellLeakagePage2 from "pages/FormAudit/Forms/state-forms/shell-leakage/page-2";
import ShellLeakagePage3 from "pages/FormAudit/Forms/state-forms/shell-leakage/page-3";
import ShellLeakagePage4 from "pages/FormAudit/Forms/state-forms/shell-leakage/page-4";

// notice of survey pages

// insulation certificate pages 

function Routes() {
  return (
    <Switch>

      {/* accessible by users that are logged in
      and users that are not logged in */}
      <PublicRoute path='/login'>
        <Login />
      </PublicRoute>

      <Route path='/prtherms'>
        <PRThermCalculator/>
      </Route>
      <Route path='/therms'>
        <ThermCalculator/>
      </Route>

      <PrivateRoute path='/home'>
        <Home/>
      </PrivateRoute>

      <PrivateRoute path='/fetch-leads'>
        <LeadFetcher/>
      </PrivateRoute>

      <PrivateRoute path='/therm-report' roles={['admin']}>
        <ThermReport/>
      </PrivateRoute>

      <PrivateRoute path='/two-step-verification'>
        <TwoStepVerification/>
      </PrivateRoute>
      <PrivateRoute path='/users/:userId/accounts/:accountId'>
        <AccountAccess/>
      </PrivateRoute>
      <PrivateRoute exact path='/users/registration'>
        <UserRegistration/>
      </PrivateRoute>
      <PrivateRoute path='/users/:userId'>
        <ManageUser/>
      </PrivateRoute>
      <PrivateRoute path='/users'>
        <Users/>
      </PrivateRoute>

      <PrivateRoute path='/accounts/:accountId'>
        <UpdateAccount />
      </PrivateRoute>
      <PrivateRoute path='/accounts'>
        <Accounts/>
      </PrivateRoute>

      {/* interim */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/casInterim/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <CASInterim />
      </PrivateRoute>
      
      {/* window and door */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/windowAndDoor/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <WindowAndDoor />
      </PrivateRoute>

      {/* notice of survey */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/noticeOfSurvey/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <NoticeOfSurvey />
      </PrivateRoute>

      {/* insulation certificate */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/insulationCertificate/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InsulationCertificate />
      </PrivateRoute>

      {/* repaired and replaced */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/repairedAndReplacedPage1/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <RepairedAndReplacedPage1 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/repairedAndReplacedPage2/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <RepairedAndReplacedPage2 />
      </PrivateRoute>

      {/* inspection */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage1/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage1 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage2/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage2 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage3/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage3 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage4/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage4 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage5/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage5 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage6/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage6 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage7/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage7 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage8/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage8 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage9/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage9 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage10/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage10 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/inspectionPage11/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <InspectionPage11 />
      </PrivateRoute>

      {/* compliance */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/complianceReportPage1/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ComplianceReportPage1 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/complianceReportPage2/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ComplianceReportPage2 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/complianceReportPage3/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ComplianceReportPage3 />
      </PrivateRoute>
      
      {/* duct */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/ductLeakagePage1/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <DuctLeakagePage1 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/ductLeakagePage2/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <DuctLeakagePage2 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/ductLeakagePage3/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <DuctLeakagePage3 />
      </PrivateRoute>

      {/* shell leakage */}
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/shellLeakagePage1/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ShellLeakagePage1 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/shellLeakagePage2/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ShellLeakagePage2 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/shellLeakagePage3/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ShellLeakagePage3 />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/shellLeakagePage4/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ShellLeakagePage4 />
      </PrivateRoute>

      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/sce/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <SCE />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/wxwo/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <WXWO />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/washer/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <WASHER />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/aiwo/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <AIWO />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/duct/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <DUCT />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/ngat/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <NGAT />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber/appointment/:appointmentId/form/noc/:version/:submissionId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <NOC />
      </PrivateRoute>
      <PrivateRoute exact path='/customers/:enrollmentNumber/appointment/:appointmentId' roles={['auditor.initial', 'auditor.final', 'auditor', 'scheduler', 'admin', 'tech.admin']}>
        <ViewForms />
      </PrivateRoute>
      <PrivateRoute exact path='/customers/:enrollmentNumber/appointment/:appointmentId/reassign' roles={['scheduler', 'auditor', 'admin', 'tech.admin']}>
        <SubmitAppointment />
      </PrivateRoute>
      <PrivateRoute exact path='/customers/:enrollmentNumber/submit-appointment' roles={['scheduler', 'auditor', 'admin', 'tech.admin']}>
        <SubmitAppointment />
      </PrivateRoute>
      <PrivateRoute path='/customers/register'>
        <CustomerRegister />
      </PrivateRoute>
      <PrivateRoute path='/customers/:enrollmentNumber'>
        <CustomerInfo />
      </PrivateRoute>
      <PrivateRoute exact path='/customers'>
        <CustomerBin />
      </PrivateRoute>
      <PrivateRoute exact path='/audit' roles={['auditor.initial', 'auditor.final', 'auditor', 'admin']}>
        <AuditingList />
      </PrivateRoute>
      <PrivateRoute exact path='/audit/:appointmentId' roles={['auditor.initial', 'auditor.final', 'auditor', 'admin']}>
        <AuditingAppointment />
      </PrivateRoute>
      <PrivateRoute exact path='/invoicing' roles={['admin']}>
        <Regions />
      </PrivateRoute>
      <PrivateRoute exact path='/invoicing/:region' roles={['admin']}>
        <RegionInvoicing />
      </PrivateRoute>

      <PrivateRoute path='/reset-password'>
        <PasswordReset/>
      </PrivateRoute>

      <Route exact path='/'>
        <Redirect to='/login'/>
      </Route>
    </Switch>
  )
}

export default Routes;